export default __webpack_public_path__ + "static/ampm@1x-dd6797ca047f6b0fa4347a831f460aa4.jpg";